var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9 1.7H6.1C4.7 1.7 3.6 3 3.6 4.6v22.9c0 1.5 1.1 2.8 2.4 2.8h19.8c1.3 0 2.4-1.3 2.4-2.8V4.6c.2-1.6-.9-2.9-2.3-2.9m-1 25.2H7.1V5.1h8.4V10c0 .5.2.9.5 1.2s.8.5 1.2.5l7.7.1zm0-18.4h-5.8V5.1h5.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 20.6h-7.6c-1 0-1.9.8-1.9 1.8s.8 1.8 1.9 1.8h7.6c1 0 1.9-.8 1.9-1.8s-.9-1.8-1.9-1.8m-9.6-3.9c0 1 .8 1.8 1.9 1.8h7.6c1 0 1.9-.8 1.9-1.8s-.8-1.8-1.9-1.8h-7.6c-1 0-1.9.8-1.9 1.8"
  })));
};
export default SvgReport;